import React from 'react';
import { createComponent, PropTypes } from "../../../wayin-react";
import { toUIProps } from "../../../util";
import { positions, colors, directions } from "../../../enums";
import classnames from 'classnames';
import { removeProps, whitelistStyles, mapHandlers } from "../hoc";
import { compose } from 'react-recompose';
import { Menu as UIMenu } from 'semantic-ui-react';
import Tooltip from "../tooltip";
var UNSUPPORTED_PROPS = ['as', 'active', 'className', 'disabled', 'icon', 'link', 'position' // unsupported until we have a use case for this
];
var ADDED_PROPS = ['id', 'isActive', 'isHeader', 'isIconOnly', 'isDisabled', 'isDivided', 'fitted', 'dataTitle', 'value', 'tooltip', 'tooltipPosition', 'tooltipIsInline', 'tooltipIsCompact', 'tooltipIsMultiline'];
var MODIFIED_PROPS = ['fitted', 'color', // allows us to pass it as a classname vs. a prop to avoid semantic-ui-react warnings
'style' // 'position',
];
var propMap = {
  isActive: 'active',
  isHeader: 'header',
  isIconOnly: 'icon',
  isDisabled: 'disabled'
};
var MenuItem = createComponent({
  displayName: 'MenuItem',
  propTypes: {
    children: PropTypes.node,
    content: PropTypes.node,
    // shorthand instead of children, children overrides; mutually exclusive
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string,
    // will be used for content if neither children nor content props are defined

    /** Style as the currently chosen item. */
    isActive: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    isHeader: PropTypes.bool,
    isIconOnly: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isDivided: PropTypes.bool,
    color: PropTypes.oneOf(colors.CORE),
    fitted: PropTypes.oneOf(directions.BASIC),
    // position: PropTypes.oneOf( positions.LR ), // 'left' is default
    onClick: PropTypes.func,
    // from tooltipify
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.oneOf(positions.ALL),
    tooltipIsInline: PropTypes.bool,
    tooltipIsCompact: PropTypes.bool,
    tooltipIsMultiline: PropTypes.bool
  },
  defaultProps: {
    children: null,
    // mutually exlusive w/ content
    content: undefined,
    // shows warning with null value; mutually exclusive w/ children
    value: null,
    name: null,
    isActive: false,
    isHeader: false,
    isIconOnly: false,
    isDisabled: false,
    isDivided: false,
    color: colors.ACCENT,
    fitted: null,
    // position: positions.LEFT,
    onClick: null,
    // from tooltipify
    tooltip: null,
    tooltipPosition: null,
    tooltipIsInline: true,
    tooltipIsCompact: true,
    tooltipIsMultiline: false
  },
  render: function render(props) {
    var _classnames;

    var UIProps = toUIProps({
      props: props,
      propMap: propMap,
      UNSUPPORTED_PROPS: UNSUPPORTED_PROPS,
      ADDED_PROPS: ADDED_PROPS,
      MODIFIED_PROPS: MODIFIED_PROPS
    });
    if (props.children === null) delete UIProps.children; // if (props.position === positions.RIGHT) {
    //   UIProps.position = props.position;
    // }

    UIProps.className = classnames(props.color, (_classnames = {
      divided: props.isDivided,
      fitted: !!props.fitted
    }, _classnames[props.fitted] = props.fitted === directions.H || props.fitted === directions.V, _classnames));
    return props.tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
      isCompact: props.tooltipIsCompact,
      isInline: props.tooltipIsInline,
      position: props.tooltipPosition,
      tooltip: props.tooltip,
      isMultiLine: props.tooltipIsMultiline
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames('ck', 'menu-item', {
        divided: props.isDivided
      }),
      style: props.style
    }, props.isDivided ? /*#__PURE__*/React.createElement("hr", {
      className: "menu-item-divider"
    }) : null, /*#__PURE__*/React.createElement(UIMenu.Item, UIProps))) : !props.tooltip ? /*#__PURE__*/React.createElement("div", {
      className: classnames('ck', 'menu-item', {
        divided: props.isDivided
      }),
      style: props.style
    }, props.isDivided ? /*#__PURE__*/React.createElement("hr", {
      className: "menu-item-divider"
    }) : null, /*#__PURE__*/React.createElement(UIMenu.Item, UIProps)) : null;
  }
});
export var PrivateMenuItem = mapHandlers({
  click: []
})(MenuItem);
export default compose(removeProps(['color', 'content', 'isHeader']), whitelistStyles())(PrivateMenuItem);
//# sourceMappingURL=menu-item.js.map